import React from "react";
import { StyleSheet, View } from "react-native";
import { Chip, Text } from "react-native-paper";
import { removeDuplicates } from "../CalculateItemsField";
import { ValueDisplay } from "../../ValueDisplay";
import { WarehouseItemsDisplay } from "../WarehouseItemsDisplay";
import { FieldDisplayRendererProps } from "./types";

const getCalculationResult = (formula: string, contextData: any[]): string => {
  try {
    const result = eval(formula);
    return result.toString();
  } catch (error) {
    console.error(error);
    return "0";
  }
};

export const DropdownLikeDisplayRenderer = ({
  field,
  value,
  t,
  valueStyle,
}: FieldDisplayRendererProps) => {
  if (field.valueDisplayMode === "stacked") {
    return (
      <View style={styles.stackedContainer}>
        {!field.hideLabel && (
          <Text style={styles.stackedLabel}>{t(field.label)}</Text>
        )}
        <ValueDisplay value={value} field={field} style={valueStyle} />
      </View>
    );
  }

  if (field.multiselect) {
    return (
      <View>
        <Text style={styles.label}>{t(field.label)}:</Text>
        <View style={{ gap: 10, marginTop: 5 }}>
          {Array.isArray(value) &&
            value?.map((item, index) => <Chip key={index}>{t(item)}</Chip>)}
        </View>
      </View>
    );
  }

  return (
    <View style={[styles.row, { alignItems: "flex-start" }]}>
      {!field.hideLabel && <Text style={styles.label}>{t(field.label)}:</Text>}
      <ValueDisplay
        value={value}
        field={field}
        style={valueStyle}
        collectionPickerContainerStyles={{
          alignItems: "flex-end",
        }}
      />
    </View>
  );
};

export const CollectionPickerDisplayRenderer = ({
  field,
  value,
  t,
}: FieldDisplayRendererProps) => {
  if (field.multiselect) {
    return (
      <View>
        {!field.hideLabel && <Text style={styles.label}>{t(field.label)}:</Text>}
        <View style={{ gap: 10, marginTop: 5 }}>
          {Array.isArray(value) &&
            value?.map((item, index) => (
              <Chip key={index}>{item[field.key]}</Chip>
            ))}
        </View>
      </View>
    );
  }

  return (
    <View style={[styles.row, { alignItems: "flex-start" }]}>
      {!field.hideLabel && <Text style={styles.label}>{t(field.label)}:</Text>}
      <ValueDisplay
        value={value}
        field={field}
        collectionPickerContainerStyles={{
          alignItems: "flex-end",
        }}
      />
    </View>
  );
};

export const PaymentsFormDisplayRenderer = ({
  value,
  t,
  theme,
}: FieldDisplayRendererProps) => {
  return (
    <View>
      {Array.isArray(value) &&
        value.map((item, index) => (
          <View
            key={index}
            style={{
              borderColor: theme.colors.outline,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              paddingVertical: 8,
              borderBottomWidth: 1,
            }}
          >
            <View>
              <Text>
                {t("paymentType")}: {t(item.paymentType)}
              </Text>
              <Text>
                {t("paymentAmount")}: {item.paymentAmount}
              </Text>
            </View>
          </View>
        ))}
    </View>
  );
};

export const MechanicLikeDisplayRenderer = ({
  field,
  value,
  t,
  theme,
}: FieldDisplayRendererProps) => {
  return (
    <View
      style={{
        borderBottomWidth: 1,
        borderColor: theme.colors.outline,
        paddingBottom: 16,
        marginBottom: 8,
      }}
    >
      <Text variant="titleSmall" style={styles.label}>
        {t(field.label)}:
      </Text>
      <View style={{ gap: 10, marginTop: 5 }}>
        {Array.isArray(value) &&
          value?.map((item, index) => (
            <View key={index}>
              <View key={index} style={styles.chip}>
                <Text>{item[field.key]}:</Text>
                <Text>{t(item[field.secondKey])}</Text>
              </View>
              {field.relatedObject && (
                <View style={{ marginTop: 4, gap: 4, marginLeft: 24 }}>
                  {Array.isArray(item.relatedObjectField) ? (
                    removeDuplicates(item.relatedObjectField)?.map(
                      (subItem, relatedIndex) => {
                        const currentItemCountInArray =
                          item.relatedObjectField.filter(
                            (i) => i.id === subItem.id,
                          ).length;

                        return (
                          <View key={relatedIndex} style={styles.chip}>
                            <Text variant="titleSmall">
                              {subItem[field.relatedObject.key]}
                            </Text>
                            <Text>
                              {subItem[field.relatedObject?.secondKey]} x{" "}
                              {currentItemCountInArray}
                            </Text>
                          </View>
                        );
                      },
                    )
                  ) : (
                    <Chip>
                      {item.relatedObjectField?.[field.relatedObject.key]}
                    </Chip>
                  )}
                </View>
              )}
              {field.relatedObject?.countTotal && (
                <Text style={{ alignSelf: "flex-end", marginTop: 4 }}>
                  {"\u0418\u0442\u043E\u0433\u043E"} {item[field.key]}:{" "}
                  {getCalculationResult(
                    field.relatedObject.formula,
                    item.relatedObjectField,
                  )}
                </Text>
              )}
            </View>
          ))}
      </View>
    </View>
  );
};

export const WarehouseItemsPickerDisplayRenderer = ({
  value,
  field,
}: FieldDisplayRendererProps) => {
  return <WarehouseItemsDisplay value={value} label={field.label} />;
};

const styles = StyleSheet.create({
  chip: {
    flex: 1,
    alignItems: "center",
    borderRadius: 8,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  label: {
    color: "#555555",
  },
  stackedContainer: {
    gap: 4,
  },
  stackedLabel: {
    fontWeight: "bold",
    marginTop: 8,
    marginBottom: 4,
  },
});
